var tagModelForSuggestionId = window.tagModelForSuggestionId;
var dismissCoauthorSuggestion = window.dismissCoauthorSuggestion;
var confirmCoauthorSuggestion = window.confirmCoauthorSuggestion;
var addCoauthorHover = window.addCoauthorHover;
var addCoauthorHover, confirmCoauthorSuggestion, dismissCoauthorSuggestion, tagModelForSuggestionId;
addCoauthorHover = function ($target) {
  if ($target.data('bs.popover')) {
    return;
  }
  new Works.CoauthorTagEdit({
    el: $target,
    model: new Works.CoauthorTag($target.data('suggested-tag'))
  });
  return $target.mouseenter();
};
tagModelForSuggestionId = function (suggestionId) {
  var data;
  data = $("*[data-coauthor-suggestion-notification=" + suggestionId + "]").data('suggested-tag');
  return new Works.CoauthorTag(data);
};
confirmCoauthorSuggestion = function ($target) {
  var suggestionId;
  suggestionId = $target.data('confirm-coauthor-suggestion');
  $target.html('<i class="fa fa-spinner fa-spin"></i>');
  return tagModelForSuggestionId(suggestionId).save().done(function () {
    $target.html('<i class="fa fa-check"></i>&nbsp;&nbsp;Confirmed');
    return $("*[data-dismiss-coauthor-suggestion=" + suggestionId + "]").parent('.notification-message-dismiss').remove();
  });
};
dismissCoauthorSuggestion = function ($target) {
  var suggestionId;
  suggestionId = $target.data('dismiss-coauthor-suggestion');
  $target.html('<i class="fa fa-spinner fa-spin"></i>');
  return tagModelForSuggestionId(suggestionId).rejectAsSuggestion().done(function () {
    $target.parents('.panel').fadeOut();
    return $target.parents('.notification-popover').fadeOut();
  });
};
$(document).on('mouseenter', '*[data-coauthor-suggestion-notification]', function (e) {
  return addCoauthorHover($(e.currentTarget));
});
$(document).on('click', '*[data-confirm-coauthor-suggestion]', function (e) {
  e.preventDefault();
  return confirmCoauthorSuggestion($(e.currentTarget));
});
$(document).on('click', '*[data-dismiss-coauthor-suggestion]', function (e) {
  return dismissCoauthorSuggestion($(e.currentTarget));
});
window.addCoauthorHover = addCoauthorHover;
window.confirmCoauthorSuggestion = confirmCoauthorSuggestion;
window.dismissCoauthorSuggestion = dismissCoauthorSuggestion;
window.tagModelForSuggestionId = tagModelForSuggestionId;